const axios = require("axios");
const API_ROOT = "http://hotspot.valenet.io/api"; //'http://hotspot.valenet.io/api'          'http://localhost:10088'

const qs = (params) => {
	return Object.keys(params)
		.map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
		.join("&");
};

const request = (path, queryParams) => {
	if (queryParams) {
		path += "?" + qs(queryParams);
	}
	const endopoint = `${API_ROOT}/${path}`;
	console.log(path);
	return axios.get(endopoint);

	/*
    return fetch(endopoint, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        //credentials: "same-origin", // include, *same-origin, omit
        //headers: {
        //    "Content-Type": "application/json; charset=utf-8",
            // "Content-Type": "application/x-www-form-urlencoded",
        //},
        //redirect: "follow", // manual, *follow, error
        //referrer: "no-referrer", // no-referrer, *client
        //body: JSON.stringify(data), // body data type must match "Content-Type" header
    })*/
};

const cleanMask = function(number) {
	var ret = number;
	ret = ret.split("(").join("");
	ret = ret.split(")").join("");
	ret = ret.split("-").join("");
	ret = ret.split(" ").join("");
	ret = ret.split(".").join("");
	return ret;
};

export const send = (number, email, cpf, env) => {
	var numberUnmask = cleanMask(number);
	var cpfUnmask = cleanMask(cpf);
	return request("send", { number: "55" + numberUnmask, email: email, cpf: cpfUnmask, env: JSON.stringify({envId: env.envId, userProfile: env.userProfile, autoLogin: env.autoLogin})});
};

export const validate = (number, code, mac_address, email, cpf, env) => {
	var numberUnmask = cleanMask(number);
	var cpfUnmask = cleanMask(cpf);

	return request("validate", { number: numberUnmask, code: code, mac_address: mac_address, email: email, cpf: cpfUnmask, env: JSON.stringify({envId: env.envId, userProfile: env.userProfile, autoLogin: env.autoLogin}) });
};

export default {
	validate,
	send,
};
